import { Box, useTheme } from "@mui/material";


import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as ReturnPackage } from "../../../../styles/svg/package-return.svg";
import { tokens } from "../../../../theme";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import Text from "../../../theme/text/Text";
import { ActionButton } from "./components/ActionButton";
import { ActionIcon } from "./components/ActionIcon";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import LinkIcon from '@mui/icons-material/Link';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
const AMInboundProcessing = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const language = useSelector((state) => state.settings.language);
    const workSpace = useSelector((state) => state.settings.workSpace);
    const themeMode = useSelector((state) => state.settings.themeMode);
    const dispatch = useDispatch();
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const [open, setOpen] = useState(false);

    
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display:"flex",
                    gap:1,
                    flexDirection:"column",
                    borderRadius:"24px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
                {!props.invoiceId &&
                <ActionButton
                    onClick={() => props.linkCostModal.setOpen(true)}
                >
                    <ActionIcon>
                        <LinkIcon fontSize="small"/>
                    </ActionIcon>

                    <Box>
                        <Text>
                        {t('link_invoice_product')}
                        </Text>
                    </Box>
                </ActionButton>
                }
                {props.printAllBarcodesModal &&
                <ActionButton
                    onClick={() => props.printAllBarcodesModal.setOpen(true)}
                >
                    <ActionIcon>
                        <PrintOutlinedIcon fontSize="small"/>
                    </ActionIcon>

                    <Box>
                        <Text>
                        {t('print_all_barcodes')}
                        </Text>
                    </Box>
                </ActionButton>
                }
                <ActionButton
                    onClick={() => props.completeInboundModal.setOpen(true)}
                >
                    <ActionIcon>
                        <DoneAllIcon fontSize="small"/>
                    </ActionIcon>

                    <Box>
                        <Text>
                        {t('complete')}
                        </Text>
                    </Box>
                </ActionButton>
               
            </Box>
            

        </PopoverModal>
    );
}

export default AMInboundProcessing;
